import React, { memo } from "react";
import { Checkbox, FormControlLabel } from "@mui/material";
import { Controller } from "react-hook-form";
import StyledFormControl from "./StyledFormControl";
import StyledToolTip from "../UI/StyledToolTip";
import { BpCheckedIcon, BpIcon, CheckBoxUI } from "./StyledCheckboxInput";

const StyledCheckboxInputs = ({
  name,
  control,
  rules = {},
  defaultValue = false,
  label,
  sx = {},
  onChange = null,
  showError = true,
  disabled = false,
  ...props
}) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      defaultValue={defaultValue}
      render={({ field, fieldState, formState: { name: fieldName } }) => {
        const { error } = fieldState;
        const {
          showLabel = false,
          helperText = error?.message || props.helperText,
        } = props;

        return (
          <StyledFormControl
            label={showLabel ? label : undefined}
            id={name}
            helperText={showError ? helperText : null}
            error={!!error}
            showLabel={showLabel}
            sx={sx}
          >
            <StyledToolTip
              title={showError ? "" : helperText || ""}
              arrow
              placement="top"
            >
              <FormControlLabel
                label={!showLabel ? label : ""}
                control={
                  <CheckBoxUI
                    checkedIcon={<BpCheckedIcon />}
                    icon={<BpIcon />}
                    {...field}
                    {...props}
                    checked={!!field.value}
                    disabled={disabled}
                    onChange={(e) => {
                      if (onChange) {
                        onChange(e, field.onChange, fieldName);
                      } else {
                        field.onChange(e.target.checked);
                      }
                    }}
                  />
                }
              />
            </StyledToolTip>
          </StyledFormControl>
        );
      }}
    />
  );
};

export default memo(StyledCheckboxInputs);
